import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { If } from 'utils';
import { UiKit } from 'components';
import { ReactComponent as VerticalEllipsis } from 'assets/img/icons/dots-menu.svg';

/**
 * @param {Object} props
 * @param {object[]} props.items
 * @param {import('utils/types').Size} props.size
 * @param {import('utils/types').XAlign} props.align
 * @param {import('utils/types').DropdownDirection} props.direction
 * @param {boolean} props.isDisabled
 * @param {string} props.className
 * @param {string} props.triggerClassName
 * @param {string} props.menuClassName
 * @param {string} props.optionClassName
 * @param {Function} props.onClick
 */
export default function ActionsDropdown({
  items = [],
  size = 'md',
  align = 'right',
  direction = 'down',
  isDisabled = false,
  className = '',
  triggerClassName = '',
  menuClassName = '',
  optionClassName = '',
  onClick = () => {}
}) {
  const options = items.map((item, index) => {
    return (
      <UiKit.Dropdown.Option
        key={index}
        onClick={item.onClick}
        disabled={item.disabled}
        className={optionClassName}
      >
        {item.title}
      </UiKit.Dropdown.Option>
    );
  });

  return (
    <UiKit.Dropdown
      onClick={onClick}
      direction={direction}
      disabled={isDisabled}
      className={cn(styles.container, className)}
    >
      <UiKit.Dropdown.Trigger
        size={size}
        caret={false}
        className={cn(styles.trigger, triggerClassName)}
      >
        <VerticalEllipsis />
      </UiKit.Dropdown.Trigger>
      <If test={options.length}>
        <UiKit.Dropdown.Menu align={align} className={menuClassName}>
          {options}
        </UiKit.Dropdown.Menu>
      </If>
    </UiKit.Dropdown>
  );
}
